<div class="row">
    <label class="col-sm-4" *ngIf="translateKey">{{label | translate}}</label>
    <label class="col-sm-4" *ngIf="!translateKey">{{label}}</label>
    <input class="col-sm-7" disabled kendoTextBox name="label" [(ngModel)]="model[translateService.currentLang]">
    <button kendoButton div class="col-sm-1" icon="globe" fillmode="outline" themeColor="secondary" (click)="onTranslateButtonClicked(model)"></button>
</div>
<app-translation-modal #translationModal (confirm)="onTranslationsConfirmed()"></app-translation-modal>